import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();

		state.isPqyUser = false;

		state.selectedRows = [];
		state.resultList = [];
		state.useYnList = [];
		state.lgrpList = [];
		state.sgrpList = [];
		state.ipnWayList = [];
		state.icrtList = [];
		state.sgrpAllList = [];
		state.detailList = [];
	},
	[types.ROW_INIT]: state => {
		state.selectedRows = [];
		state.detailList = [];
	},
	[types.DETAIL_LIST]: (state, { status, changeArr }) => {
		if (status === 'add') {
			state.detailList = state.detailList.concat(changeArr);
		} else {
			state.detailList = [].concat(changeArr);
		}
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
